import type { FC } from 'react';

import type { AcquiringType, PaymentType } from 'types/payment';
import { acquiringIconType } from 'utils';
import { SpinnerIcon } from 'views/shared/spinner-icon';

type AcquiringsItemPropTypes = {
  paymentData: PaymentType | null;
  acquiringsItem: AcquiringType;
  handleSelectAcquiring: (values: AcquiringType) => void;
  isLoading: boolean;
};

const AcquiringsItem: FC<AcquiringsItemPropTypes> = ({
  paymentData,
  acquiringsItem,
  isLoading,
  handleSelectAcquiring,
}) => {
  return (
    <button
      type="button"
      key={acquiringsItem.ID}
      onClick={() => handleSelectAcquiring(acquiringsItem)}
      className="rounded-[8px] bg-white px-[14px] py-3 md:px-4 md:py-5 flex items-center justify-center gap-2 md:w-[160px] hover:shadow-sm active:shadow h-[52px] md:h-[72px]"
    >
      {isLoading ? (
        <SpinnerIcon className="stroke-black" />
      ) : (
        <>
          {paymentData && (
            <img
              src={acquiringIconType(paymentData?.paymentType, acquiringsItem.formType)}
              className="w-6 h-6"
              alt="logo"
            />
          )}
          <span className="text-sm leading-4 text-left w-min">{acquiringsItem.title}</span>
        </>
      )}
    </button>
  );
};

export { AcquiringsItem };
